import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="栏目分类"
          title="按类型去找你想看的瓜"
          desc="不同话题的梳理方式不太一样，先选一个方向，关系图和链条都会跟着变。"
          align="center"
        />
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat, index) => {
            const accentStyles = [
              'bg-primary-100 text-primary-700',
              'bg-accent-100 text-accent-800',
              'bg-secondary-100 text-secondary-900',
              'bg-primary-100 text-primary-700',
              'bg-accent-100 text-accent-800',
            ];
            return (
              <Link
                key={cat.id}
                to={`/cases?category=${cat.id}`}
                className="group bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors cursor-pointer flex flex-col"
              >
                <span
                  className={`w-11 h-11 rounded-lg flex items-center justify-center text-xl ${accentStyles[index % accentStyles.length]}`}
                >
                  <i className={cat.icon} />
                </span>
                <h3 className="mt-4 font-heading font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {cat.name}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600 flex-1">{cat.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  查看事件
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}